import request from '@/utils/request'

let Order_promotionApi = {

  /*接单/推广申请列表*/
  list(data) {
    return request._post('/shop/plus.order_promotion.Index/index', data);
},
/*添加接单/推广申请*/
add(data) {
    return request._post('/shop/plus.order_promotion.Index/add', data);
},
/*修改接单/推广申请*/
edit(data) {
    return request._post('/shop/plus.order_promotion.Index/edit', data);
},
/*删除接单/推广申请*/
del(data) {
    return request._post('/shop/plus.order_promotion.Index/del', data);
},
/*接单/推广申请详情*/
detail(data) {
  return request._post('/shop/plus.order_promotion.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.order_promotion.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.order_promotion.Setting/getSetting', data, errorback);
    },
}
export default Order_promotionApi;



// WEBPACK FOOTER //
// ./src/api/order_promotion.js